<template>
  <div class="config-ctn">
    <div v-if="isLoadingATPConfig"/>
      <!-- Main Content -->
      <div v-else>
        <h4 class="text-capitalize font-weight-bold title">{{$t('amazon_transparency_config')}}</h4>
        <div class="mt-10">
        <!-- Amazon Transparency enabled -->
        <div v-if="isATPEnabled">
          <div class="flex align-center">
            <v-icon size="22" color="#3FC135" class="mr-2">mdi-check-circle</v-icon>
            <span>{{$t('amazon_transparency_is_enabled')}}</span>
          </div>

          <div class="d-flex flex-column ml-8">
            <div class="flex align-center mt-5 mt-md-10">
              <span class="font-weight-bold mr-6 label-text">{{$t('amazon_transparency_tln_number')}}</span>
              <span>{{accountId}}</span>
            </div>
          </div>

        </div>

        <!-- Amazon Transparency disabled -->
        <div v-if="!isATPEnabled">
          <p class="config-text">
            {{$t('amazon_transparency_not_enabled')}}<br/>
            {{$t('amazon_transparency_setup_tasks')}}
          </p>

          <div class="mt-10">
            <v-form ref="form" v-model="isFormValid">
              <v-label class="label-text">{{$t('amazon_transparency_enter_tln_number')}}</v-label>
              <div class="flex align-center mt-1">
                <v-row>
                  <!-- tln form field -->
                  <v-col md="4">
                    <v-text-field
                      small
                      dense
                      outlined
                      :counter="13"
                      :rules="tlnRules"
                      required
                      v-model="form.tln"
                      :disabled="disableFormFields"
                      :placeholder="$t('amazon_transparency_tln_number')"
                    />
                  </v-col>
                  <v-col class="">
                    <v-btn
                      class="text-uppercase"
                      color="#15BBF0"
                      height="40"
                      @click="enrollBtnClick"
                      :loading="isEnrolling"
                      :disabled="!isFormValid || isEnrolling"
                    >
                      {{$t('amazon_transparency_enroll')}}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Utils from '@/utils/utils'

export default {
  name: 'Config',
  data () {
    return {
      isFormValid: false,
      isEnrolling: false,
      form: {
        tln: ''
      }
    }
  },
  methods: {
    async displaySnackbar (message) {
      await this.$store.dispatch('showSnackBar', { message: message })
    },
    async enrollBtnClick () {
      try {
        this.isEnrolling = true
        const payload = { accountId: this.form.tln }
        await this.$store.dispatch('updateATPConfig', payload)
        // register account id with the mock endpoint
        // only call endpoint in staging or dev
        if (Utils.isStagingEnvironment() || Utils.isDevEnvironment()) {
          const mockPayload = { gln: this.form.tln }
          await this.$store.dispatch('createRequesterParty', mockPayload)
        }
        this.isEnrolling = false
      } catch (error) {
        this.isEnrolling = false
        if (error?.response) {
          await this.displaySnackbar(this.$t('amazon_transparency_error_occurred'))
        } else if (error?.request) {
          await this.displaySnackbar(this.$t('amazon_transparency_no_response'))
        } else {
          await this.displaySnackbar(this.$t('amazon_transparency_error_occurred'))
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getATPConfig', 'isLoadingATPConfig']),
    isATPEnabled () {
      return this.getATPConfig && this.getATPConfig.is_enabled
    },
    accountId () {
      return this.getATPConfig.account_id
    },
    tlnRules () {
      return [
        v => !!v || this.$t('amazon_transparency_tln_required'),
        v => /^[0-9]+$/.test(v) || this.$t('amazon_transparency_numeric_allowed'),
        v => v.length === 13 || this.$t('amazon_transparency_tln_thirteen_characters')
      ]
    },
    disableFormFields () {
      return this.isEnrolling
    }
  }
}
</script>

<style lang="sass">

.config-ctn
  padding-top: 20px

  .title
    font-size: 24px
    font-style: normal
    font-weight: 700
    line-height: normal

  .config-text
    font-size: 18px
    font-style: normal
    font-weight: 300
    line-height: 26px

  .label-text
    color: #000

</style>
